import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { googleAuthLogin } from "../api";
import GoogleSignInButton from "../components/GoogleSignInButton";

export default function SignInPage({ onLogin }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleGoogleLogin = async (credential) => {
        setLoading(true);
        setError("");
        try {
            const data = await googleAuthLogin(credential);
            onLogin(data);
            navigate("/");
            window.scrollTo(0, 0);
        } catch (err) {
            setError(err.message || "Google sign-in failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 24px" }}>
            <style>{`
                .google-auth-layout {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 32px;
                    max-width: 860px;
                    width: 100%;
                }
                @media (max-width: 768px) {
                    .google-auth-layout {
                        grid-template-columns: 1fr;
                        gap: 24px;
                    }
                    .google-auth-box { padding: 28px !important; }
                }
            `}</style>

            <div className="google-auth-layout">
                <div className="google-auth-box" style={{ background: "var(--paper)", borderRadius: 22, border: "1.5px solid var(--border)", padding: 40, display: "flex", flexDirection: "column", justifyContent: "center", animation: "fadeUp 0.5s both" }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>Google</div>
                    <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 800, color: "var(--ink)", marginBottom: 12 }}>Sign In</h2>
                    <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.75, marginBottom: 28 }}>
                        Sign in with your Google account to access your profile, orders, wishlist, and admin panel.
                    </p>
                    <div style={{ marginBottom: 18 }}>
                        <GoogleSignInButton
                            mode="signin"
                            onCredential={handleGoogleLogin}
                            onError={(err) => setError(err.message || "Google sign-in failed")}
                        />
                    </div>
                    {loading && <div style={{ fontSize: 13, color: "var(--text3)" }}>Signing you in...</div>}
                    {error && <div style={{ marginTop: 12, background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#DC2626", fontWeight: 600 }}>{error}</div>}
                </div>

                <div className="google-auth-box" style={{ background: "var(--paper)", borderRadius: 22, border: "1.5px solid var(--border)", padding: 40, animation: "fadeUp 0.5s 0.1s both" }}>
                    <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 800, color: "var(--ink)", marginBottom: 12 }}>New Here?</h2>
                    <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.75, marginBottom: 28 }}>
                        New users can use the same Google button to create their account instantly. No separate email/password form is required now.
                    </p>
                    <button
                        className="btn btn-outline"
                        style={{ alignSelf: "flex-start", padding: "13px 28px" }}
                        onClick={() => {
                            navigate("/register");
                            window.scrollTo(0, 0);
                        }}
                    >
                        Go to Register
                    </button>
                </div>
            </div>
        </div>
    );
}
